import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { ProjectListScreen_GetAllDocument } from "../../ProjectListScreen/queries.generated";
import { ProjectDeleteDocument } from "../mutations.generated";

export default function useProjectDelete(projectId: string) {
    const [deleteProject, { data, loading, error }] = useMutation(ProjectDeleteDocument, {
        refetchQueries: [ProjectListScreen_GetAllDocument],
    });

    return {
        deleteProject: useCallback(
            () =>
                deleteProject({
                    variables: {
                        input: { projectId },
                    },
                }),
            [deleteProject, projectId],
        ),
        data,
        loading,
        error,
    };
}
